/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function formatApprovalDuration(totalSeconds: number) {
  const safeTotalSeconds = Math.max(0, totalSeconds);
  const hours = Math.floor(safeTotalSeconds / 3600);
  const minutes = Math.floor((safeTotalSeconds % 3600) / 60);
  const seconds = safeTotalSeconds % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}:${String(seconds).padStart(2, "0")} left`;
}
